let CTAs = document.querySelectorAll('.n-cta');

CTAs.forEach((cta) => {

  const link = cta.querySelector('.link a');

  if(!link) {
    return;
  }
  
  cta.style.cursor = 'pointer';

  cta.addEventListener('click', () => {
    window.location = link.href;
  });

});